import React from 'react';
import Drawer from 'components/drawer';
import Button from 'components/button';
import { formatCurrency } from 'libs';
import styles from './modals.module.scss';

const RequestDetails = ({ viewed, drawerActive, onClose, onProceed }) => (
  <Drawer
    title="Request Details"
    setDrawerActive={onClose}
    drawerActive={drawerActive}
  >
    <Drawer.DrawerBody>
      <div className={styles.requestDetailsItem}>
        <h5>Quantity</h5>
        <p>{viewed?.quantity}</p>
      </div>
      <div className={styles.requestDetailsItem}>
        <h5>Amount</h5>
        <p>{formatCurrency(viewed?.amount)}</p>
      </div>

      <p className={styles.requestDetailsFooter}>
        Gotten your terminal? Use the button below to activate it
      </p>
      <Button
        text="Activate Terminal"
        variant="primary"
        style={{ height: '50px' }}
        onClick={onProceed}
      />
    </Drawer.DrawerBody>
  </Drawer>
);

export default RequestDetails;
